export const FETCH_AREAS_REQUEST = "FETCH_AREAS_REQUEST";
export const UPDATE_AREA_REQUEST = "UPDATE_AREA_REQUEST";
export const CHANGE_AREA_STATUS_REQUEST = "CHANGE_AREA_STATUS_REQUEST";
export const CREATE_AREA_REQUEST = "CREATE_AREA_REQUEST";
export const CHANGE_AREA_WEIGHT_REQUEST = "CHANGE_AREA_WEIGHT_REQUEST";
